import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/insurance-info.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'
import _imports_3 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_4 from '@/app/ui/assets/svg/x-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2b489803")

_pushScopeId("data-v-2b489803")
const _hoisted_1 = {
  key: 1,
  class: "overflow-y-auto h-screen"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Configurable Price ", -1)
const _hoisted_5 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_6 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("button", { class: "cursor-not-allowed text-white bg-gray-lp-600 px-8 text-12px xxl:text-14px py-2 xxl:py-3 font-bold rounded-md focus:outline-none" }, " Simpan ", -1)
const _hoisted_8 = { class: "flex flex-row py-6" }
const _hoisted_9 = { class: "w-2/3 pr-8 pl-4 text-12px xxl:text-14px" }
const _hoisted_10 = { class: "w-3/4" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Nama Configurable Price ", -1)
const _hoisted_13 = { class: "py-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, [
  /*#__PURE__*/_createTextVNode(" Deskripsi "),
  /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, "(optional)")
], -1)
const _hoisted_15 = { class: "xxl:pt-4 xxl:pb-4 py-4 textarea-address" }
const _hoisted_16 = { class: "flex flex-col text-12px xxl:text-14px border-t border-gray-lp-400 mt-6" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold font-montserrat text-black-lp-300 text-20px pt-10 pb-8" }, [
  /*#__PURE__*/_createTextVNode(" Daftar Asuransi "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-500 text-12px xxl:text-14px font-normal" }, " Masukkan “0” disetiap input form bila tipe asuransi tidak ada ")
], -1)
const _hoisted_18 = { class: "font-semibold label-accordion flex flex-row" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 ml-2",
  alt: "info"
}, null, -1)
const _hoisted_20 = { class: "flex flex-col w-full text-gray-lp-300" }
const _hoisted_21 = { class: "flex flex-row p-10 py-8" }
const _hoisted_22 = { class: "flex flex-col w-1/2 mr-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Harga Barang Min. "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4 ml-2",
    alt: "info"
  })
], -1)
const _hoisted_24 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 border-gray-lp-400 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }, " IDR ", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "text-12px text-gray-lp-500" }, " Masukkan 0 bila tidak ada Harga Barang Min. ", -1)
const _hoisted_27 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 border-gray-lp-400 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }, " RM ", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "text-12px text-gray-lp-500" }, " Masukkan 0 bila tidak ada Harga Barang Min. ", -1)
const _hoisted_30 = { class: "flex flex-col w-1/2 mr-4" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Harga Barang Maks. "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4 ml-2",
    alt: "info"
  })
], -1)
const _hoisted_32 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_33 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_35 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_36 = { class: "flex flex-row items-center relative w-full mt-5" }
const _hoisted_37 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_39 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_40 = { class: "flex flex-row p-10 py-0" }
const _hoisted_41 = { class: "flex flex-col w-1/2 mr-4" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Harga Premi Min. "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4 ml-2",
    alt: "info"
  })
], -1)
const _hoisted_43 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_44 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_46 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_47 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_48 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_50 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_51 = { class: "flex flex-col w-1/2 mr-4" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Harga Premi Maks. "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4 ml-2",
    alt: "info"
  })
], -1)
const _hoisted_53 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_54 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_56 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_57 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_58 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_60 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_61 = { class: "flex flex-row p-10" }
const _hoisted_62 = { class: "flex flex-col w-1/2 mr-4" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Besaran Premi "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4 ml-2",
    alt: "info"
  })
], -1)
const _hoisted_64 = { class: "flex flex-row items-center relative w-1/2" }
const _hoisted_65 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 mr-6 flex items-center px-2 text-gray-700"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_67 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_68 = { class: "flex flex-col w-1/2 mr-4" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-semibold" }, " Komisi POS "),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-4 ml-2",
    alt: "info"
  })
], -1)
const _hoisted_70 = { class: "flex flex-row items-center relative w-1/2" }
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("p", { class: "text-12px text-gray-lp-500" }, " Masukkan 0 bila tidak ada Komisi POS. ", -1)
const _hoisted_73 = { class: "flex flex-col text-12px xxl:text-14px border-t border-gray-lp-400 mt-6" }
const _hoisted_74 = { class: "py-3" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Vendor", -1)
const _hoisted_76 = { class: "py-3" }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "API Url", -1)
const _hoisted_78 = { class: "py-3" }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "API Url", -1)
const _hoisted_80 = { class: "py-3" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "API Token", -1)
const _hoisted_82 = { class: "py-3 flex flex-row items-center" }
const _hoisted_83 = { class: "font-montserrat font-medium ml-6 text-gray-lp-600" }
const _hoisted_84 = { class: "flex flex-row ml-6" }
const _hoisted_85 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4 cursor-pointer",
  alt: "ok"
}, null, -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("p", { class: "font-montserrat font-medium ml-1 text-green-lp-100" }, " Check Successfull ", -1)
const _hoisted_87 = { class: "flex flex-row ml-6" }
const _hoisted_88 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-4 cursor-pointer",
  alt: "x"
}, null, -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("p", { class: "font-montserrat font-medium ml-1 text-red-lp-750" }, " Check Failed ", -1)
const _hoisted_90 = { class: "flex flex-col text-12px xxl:text-14px border-t border-gray-lp-400 mt-6" }
const _hoisted_91 = { class: "py-3" }
const _hoisted_92 = /*#__PURE__*/_createVNode("div", { class: "font-semibold mt-2 text-12px xxl:text-14px text-black-lp-300" }, " Status Configurable Price ", -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ", -1)
const _hoisted_94 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300 my-4" }
const _hoisted_95 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_96 = { class: "ml-4" }
const _hoisted_97 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_98 = { class: "py-3" }
const _hoisted_99 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Configurable Price ", -1)
const _hoisted_100 = { class: "text-gray-lp-300 my-1" }
const _hoisted_101 = { class: "flex" }
const _hoisted_102 = { class: "py-3" }
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_104 = { class: "text-gray-lp-300 my-1" }
const _hoisted_105 = { class: "text-gray-lp-500" }
const _hoisted_106 = { class: "py-3" }
const _hoisted_107 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_108 = { class: "text-gray-lp-300 my-1" }
const _hoisted_109 = { class: "text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                class: "w-5 mr-3 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", null, [
              (_ctx.isValidate)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode(_component_button_fill, {
                      title: "Simpan",
                      onClick: _ctx.openModalSave,
                      class: "px-8 bg-red-lp-300"
                    }, null, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_6, [
                    _hoisted_7
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.insurance.configPrice.configurablePriceName = $event)),
                    class: 
                `py-1.5 xxl:py-3 px-3 rounded border opacity-50 border-gray-lp-400 focus:outline-none text-black-lp-200 my-2 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                    disabled: _ctx.isDisabled
                  }, null, 10, ["disabled"]), [
                    [_vModelText, _ctx.insurance.configPrice.configurablePriceName]
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _withDirectives(_createVNode("textarea", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.insurance.configPrice.configurablePriceDescription = $event)),
                      maxlength: "250",
                      class: "textarea-inside text-black-lp-300 w-full resize-none focus:outline-none"
                    }, null, 512), [
                      [_vModelText, _ctx.insurance.configPrice.configurablePriceDescription]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.insurance.configurableInsurance.insuranceTypes, (e, i) => {
                  return (_openBlock(), _createBlock(_component_Accordion, {
                    key: i,
                    label: e.name,
                    class: "text-12px xxl:text-14px mb-5"
                  }, {
                    header: _withId(() => [
                      _createVNode("div", _hoisted_18, [
                        _createTextVNode(_toDisplayString(e.name) + " ", 1),
                        _hoisted_19
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.priceGoodsMin = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahMinPrice(i)),
                                onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.priceGoodsMin]
                              ])
                            ]),
                            _hoisted_26,
                            _createVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.priceGoodsMinMY = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahMinPriceMY(i)),
                                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.priceGoodsMinMY]
                              ])
                            ]),
                            _hoisted_29
                          ]),
                          _createVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode("div", _hoisted_32, [
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorMaxPriceGoods(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2"]
                              }, " IDR ", 2),
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        }  ${
                          _ctx.isErrorMaxPriceGoods(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahMaxPrice(i)),
                                "onUpdate:modelValue": ($event: any) => (e.priceGoodsMax = $event),
                                onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onInput", "onUpdate:modelValue"]), [
                                [_vModelText, e.priceGoodsMax]
                              ]),
                              (_ctx.isErrorMaxPriceGoods(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                                    _hoisted_34
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_35, " Harga Barang Maks. tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorMaxPriceGoods(i)]
                            ]),
                            _createVNode("div", _hoisted_36, [
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorMaxPriceGoodsMY(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2"]
                              }, " RM ", 2),
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        }  ${
                          _ctx.isErrorMaxPriceGoodsMY(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahMaxPriceMY(i)),
                                "onUpdate:modelValue": ($event: any) => (e.priceGoodsMaxMY = $event),
                                onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onInput", "onUpdate:modelValue"]), [
                                [_vModelText, e.priceGoodsMaxMY]
                              ]),
                              (_ctx.isErrorMaxPriceGoodsMY(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_37, [
                                    _hoisted_38
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_39, " Harga Barang Maks. tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorMaxPriceGoodsMY(i)]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_40, [
                          _createVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createVNode("div", _hoisted_43, [
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorMinInsurancePayment(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2"]
                              }, " IDR ", 2),
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        } ${
                          _ctx.isErrorMinInsurancePayment(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.pricePremiMin = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahPremiMin(i)),
                                onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.pricePremiMin]
                              ]),
                              (_ctx.isErrorMinInsurancePayment(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                                    _hoisted_45
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_46, " Harga Premi Min. tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorMinInsurancePayment(i)]
                            ]),
                            _createVNode("div", _hoisted_47, [
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorMinInsurancePaymentMY(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2"]
                              }, " RM ", 2),
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        } ${
                          _ctx.isErrorMinInsurancePaymentMY(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.pricePremiMinMY = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahPremiMinMY(i)),
                                onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.pricePremiMinMY]
                              ]),
                              (_ctx.isErrorMinInsurancePayment(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_48, [
                                    _hoisted_49
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_50, " Harga Premi Min. tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorMinInsurancePaymentMY(i)]
                            ])
                          ]),
                          _createVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createVNode("div", _hoisted_53, [
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorMaxInsurancePayment(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2"]
                              }, " IDR ", 2),
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        } ${
                          _ctx.isErrorMaxInsurancePayment(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.pricePremiMax = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahPremiMax(i)),
                                onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.pricePremiMax]
                              ]),
                              (_ctx.isErrorMaxInsurancePayment(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                    _hoisted_55
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_56, " Harga Premi Maks. tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorMaxInsurancePayment(i)]
                            ]),
                            _createVNode("div", _hoisted_57, [
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorMaxInsurancePaymentMY(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2"]
                              }, " RM ", 2),
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        } ${
                          _ctx.isErrorMaxInsurancePaymentMY(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.pricePremiMaxMY = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatRupiahPremiMaxMY(i)),
                                onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.pricePremiMaxMY]
                              ]),
                              (_ctx.isErrorMaxInsurancePaymentMY(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_58, [
                                    _hoisted_59
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_60, " Harga Premi Maks. tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorMaxInsurancePaymentMY(i)]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_61, [
                          _createVNode("div", _hoisted_62, [
                            _hoisted_63,
                            _createVNode("div", _hoisted_64, [
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        } ${
                          _ctx.isErrorInsuranceCost(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "py-1.5 w-full xxl:py-3 px-3 rounded-r-none rounded-l-md border focus:outline-none focus:shadow my-1.5 text-black-lp-300"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.cost = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatFeeInsurance(i)),
                                onKeydown: _cache[12] || (_cache[12] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.cost]
                              ]),
                              (_ctx.isErrorInsuranceCost(i))
                                ? (_openBlock(), _createBlock("div", _hoisted_65, [
                                    _hoisted_66
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", {
                                class: [
                        `${
                          _ctx.isErrorInsuranceCost(i)
                            ? 'border-red-lp-100'
                            : 'border-gray-lp-400'
                        }`
                      , "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5"]
                              }, " % ", 2)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_67, " Besaran Premi tidak boleh 0 ", 512), [
                              [_vShow, _ctx.isErrorInsuranceCost(i)]
                            ])
                          ]),
                          _createVNode("div", _hoisted_68, [
                            _hoisted_69,
                            _createVNode("div", _hoisted_70, [
                              _withDirectives(_createVNode("input", {
                                disabled: _ctx.isInputShouldDisabled(e),
                                class: [
                        `${
                          _ctx.isInputShouldDisabled(e) ? 'cursor-not-allowed' : ''
                        }`
                      , "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"],
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (e.commisionPos = $event),
                                onInput: ($event: any) => (_ctx.onInputFormatCommisionPos(i)),
                                onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                              }, null, 42, ["disabled", "onUpdate:modelValue", "onInput"]), [
                                [_vModelText, e.commisionPos]
                              ]),
                              _hoisted_71
                            ]),
                            _hoisted_72
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_73, [
                _createVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "py-1.5 xxl:py-3 px-3 w-1/3 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.insurance.configurableInsurance.insuranceVendorName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.insurance.configurableInsurance.insuranceVendorName]
                  ])
                ]),
                _createVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.apiData,
                    onOpenSelect: _ctx.onOpenApiSelect,
                    onCloseSelect: _ctx.onCloseApiSelect,
                    isOpenMenu: _ctx.apiSelect,
                    onChooseSelect: _ctx.onSelectApi,
                    value: _ctx.insurance.configurableInsurance.insuranceIsApiUrl,
                    class: "w-1/3 whitespace-no-wrap"
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "value"])
                ]),
                _withDirectives(_createVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "py-1.5 xxl:py-3 px-3 w-3/4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.insurance.configurableInsurance.insuranceApiUrl = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.insurance.configurableInsurance.insuranceApiUrl]
                  ])
                ], 512), [
                  [_vShow, _ctx.insurance.configurableInsurance.insuranceIsApiUrl === 'yes']
                ]),
                _withDirectives(_createVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "py-1.5 xxl:py-3 px-3 w-3/4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.insurance.configurableInsurance.insuranceApiToken = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.insurance.configurableInsurance.insuranceApiToken]
                  ])
                ], 512), [
                  [_vShow, _ctx.insurance.configurableInsurance.insuranceIsApiUrl === 'yes']
                ]),
                _withDirectives(_createVNode("div", _hoisted_82, [
                  _createVNode("div", null, [
                    _createVNode(_component_button_fill, {
                      title: "Test API",
                      onClick: _ctx.testApi,
                      class: "px-8 bg-red-lp-300"
                    }, null, 8, ["onClick"])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_83, " API On Check... ", 512), [
                    [_vShow, _ctx.showTest]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_84, [
                    _hoisted_85,
                    _hoisted_86
                  ], 512), [
                    [_vShow, _ctx.showSuccess]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _hoisted_89
                  ], 512), [
                    [_vShow, _ctx.showError]
                  ])
                ], 512), [
                  [_vShow, _ctx.insurance.configurableInsurance.insuranceIsApiUrl === 'yes']
                ])
              ]),
              _createVNode("div", _hoisted_90, [
                _createVNode("div", _hoisted_91, [
                  _hoisted_92,
                  _hoisted_93,
                  _createVNode("div", _hoisted_94, [
                    _createVNode("div", {
                      onClick: _cache[17] || (_cache[17] = () => _ctx.onOpenStatusConfigurablePrice()),
                      class: 
                  `toggle-switch inline-block cursor-pointer ${
                    _ctx.statusInsurance()
                      ? 'toggle-active bg-red-lp-100'
                      : 'bg-gray-lp-200'
                  }`
                
                    }, [
                      _hoisted_95
                    ], 2),
                    _createVNode("div", _hoisted_96, " Configurable Price " + _toDisplayString(_ctx.statusInsurance() ? "Aktif" : "Tidak Aktif"), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_97, [
              _createVNode("div", _hoisted_98, [
                _hoisted_99,
                _createVNode("div", _hoisted_100, [
                  _createVNode("div", _hoisted_101, [
                    _createVNode("div", {
                      class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.statusInsurance() ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${
                    _ctx.statusInsurance() ? 'text-green-lp-200' : 'text-red-lp-500'
                  }`
                
                    }, [
                      _createVNode("span", null, _toDisplayString(_ctx.statusInsurance() ? "Active" : "Inactive"), 1)
                    ], 2)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_102, [
                _hoisted_103,
                _createVNode("div", _hoisted_104, _toDisplayString(_ctx.formatDate(_ctx.insurance.configPrice.configurablePriceCreatedAt)), 1),
                _createVNode("div", _hoisted_105, _toDisplayString(_ctx.insurance.configPrice.configurablePriceCreatedBy), 1)
              ]),
              _createVNode("div", _hoisted_106, [
                _hoisted_107,
                _createVNode("div", _hoisted_108, _toDisplayString(_ctx.insurance.configPrice.configurablePriceUpdatedAt ===
                "0001-01-01T00:00:00Z" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === "" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === null
                ? _ctx.formatDate(_ctx.insurance.configPrice.configurablePriceCreatedAt)
                : _ctx.formatDate(_ctx.insurance.configPrice.configurablePriceUpdatedAt)), 1),
                _createVNode("div", _hoisted_109, _toDisplayString(_ctx.insurance.configPrice.configurablePriceUpdatedAt ===
                "0001-01-01T00:00:00Z" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === "" ||
              _ctx.insurance.configPrice.configurablePriceUpdatedAt === null
                ? _ctx.insurance.configPrice.configurablePriceCreatedBy
                : _ctx.insurance.configPrice.configurablePriceUpdatedBy), 1)
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseStatusConfigurablePrice,
      onSubmit: _ctx.changeStatusConfigurablePrice,
      title: "Non-aktifkan Configurable Price",
      message: "Non Aktif Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
      image: "warning",
      textSuccess: "Non-aktifkan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openStatusConfigurablePrice]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.handlerCancelClose,
      onSubmit: _ctx.handlerClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalSuccess,
      title: "Perubahan Disimpan",
      message: `${_ctx.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.modalSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onEditConfigPrice,
      onClose: _ctx.closeModalSave,
      title: "Konfirmasi Perubahan Configurable Price",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Detail “${_ctx.insurance.configPrice.configurablePriceName}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
})